import { ArrowDown } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";
import { useLang } from "@/context/LanguageContext";

const ImageCard = ({ src, label, caption, testId }) => (
  <div data-testid={testId} className="relative">
    <div className="relative overflow-hidden ring-1 ring-inset ring-[#D4AF37]/30 shadow-lg bg-[#0A1128]">
      <img src={src} alt={caption} className="w-full h-full object-cover aspect-[16/10]" />
      <span className="absolute top-4 left-4 bg-[#0A1128]/85 text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-semibold px-3 py-1.5">
        {label}
      </span>
    </div>
    <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{caption}</p>
  </div>
);

export const SuccessStory = ({ onDonate }) => {
  const { t } = useLang();
  return (
    <section id="success-story" data-testid="success-story-section" className="relative bg-white py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Narrative */}
          <div className="lg:col-span-6">
            <Reveal>
              <Overline>{t("resilience.overline")}</Overline>
              <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0A1128]">
                {t("resilience.title")}
              </h2>
              <blockquote className="mt-8 border-l-2 border-[#D4AF37] pl-5 font-display italic text-xl md:text-2xl text-[#1D3557] leading-snug">
                {t("resilience.quote")}
              </blockquote>
              <div className="mt-8 space-y-5 text-base md:text-lg text-[#4B5563] leading-relaxed">
                <p>{t("resilience.p1")}</p>
                <p>{t("resilience.p2")}</p>
                <p>{t("resilience.p3")}</p>
              </div>
              <button
                data-testid="success-story-donate"
                onClick={onDonate}
                className="mt-8 inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-[#0A1128] font-semibold hover:bg-[#E5C158] hover:scale-[1.03] transition-all duration-300"
              >
                {t("resilience.cta")} <span>→</span>
              </button>
            </Reveal>
          </div>

          {/* Before (top) → After (bottom) */}
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <ImageCard testId="story-before" src="/icdh-before.jpg" label={t("resilience.beforeLabel")} caption={t("resilience.beforeCaption")} />
            </Reveal>
            <div className="flex justify-center my-6">
              <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#0A1128] text-[#D4AF37]">
                <ArrowDown size={22} />
              </span>
            </div>
            <Reveal delay={0.15}>
              <ImageCard testId="story-after" src="/icdh-after.jpg" label={t("resilience.afterLabel")} caption={t("resilience.afterCaption")} />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
